import 'leaflet-rotatedmarker';
import { type ReactElement } from 'react';
import { allCamerasFilter, trafficCamera } from '../LayerFactories';
import { LeafletMap } from '../Map';
import { TrafficCameraSource } from '../Sources/TrafficCameraSource';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

interface CameraPageMapProps extends PageMapProps {
    cameraPageId: number;
}

export const CameraPageMap = (props: CameraPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        const cameraLayer = trafficCamera(mapProps.region, null, {
            source: new TrafficCameraSource(null, null, {
                id: 'single-traffic-camera-source',
                url: `/api/trafficcameras/${props.cameraPageId}`,
            }),
            persistentInformationLayer: true,
            disablePopup: true,
            name: 'SingleCamera',
            animate: false,
        }).addTo(map);
        allCamerasFilter([cameraLayer]).addTo(map);
    };

    return <LeafletMap {...mapProps} disableFullscreenControl={true} startOnFeatureBounds={true} onMapInitiated={setupMap} />;
};
